export const ADULT_CONTACT_AGE_THRESHOLD = 16;

export const parseAgeGroupMinAge = (ageGroup: string): number | null => {
  const normalized = ageGroup.trim().toLowerCase();
  if (!normalized) return null;

  const plusMatch = normalized.match(/^(\d+)\s*\+/);
  if (plusMatch) return Number(plusMatch[1]);

  const andUpMatch = normalized.match(/^(\d+)\s+and\s+(up|above|older)/);
  if (andUpMatch) return Number(andUpMatch[1]);

  const rangeMatch = normalized.match(/^(\d+)\s*-\s*(\d+)/);
  if (rangeMatch) return Number(rangeMatch[1]);

  const singleMatch = normalized.match(/^(\d+)$/);
  if (singleMatch) return Number(singleMatch[1]);

  return null;
};

export const isAdultAgeGroup = (ageGroup: string): boolean => {
  const minAge = parseAgeGroupMinAge(ageGroup);
  if (minAge === null) return false;
  return minAge >= ADULT_CONTACT_AGE_THRESHOLD;
};

export const isAdultEnrollment = (enrollment: {
  participantAge?: string | null;
  participantActualAge?: number | string | null;
}): boolean => {
  if (enrollment.participantAge?.trim()) {
    return isAdultAgeGroup(enrollment.participantAge);
  }
  const age = Number(enrollment.participantActualAge);
  return !isNaN(age) && age >= ADULT_CONTACT_AGE_THRESHOLD;
};
